import { z } from 'zod';

// Top climber entry (for home page section)
export const TopClimberEntrySchema = z.object({
  rank: z.number(),
  user_id: z.string().uuid(),
  username: z.string(),
  avatar_url: z.string().nullable().optional(),
  rating_change: z.number(),
  votes_in_gw: z.number(),
  success_rate_gw: z.number(),
  twitter_username: z.string().nullable().optional(),
  show_twitter_username: z.boolean().optional(),
});

export type TopClimberEntry = z.infer<typeof TopClimberEntrySchema>;

// Top climbers response
export const TopClimbersResponseSchema = z.object({
  gameweek_number: z.number(),
  gameweek_id: z.string().uuid(),
  top_climbers: z.array(TopClimberEntrySchema),
});

export type TopClimbersResponse = z.infer<typeof TopClimbersResponseSchema>;

// GW-specific leaderboard entry (extends standard profile with GW fields)
export const GameweekLeaderboardEntrySchema = z.object({
  // Standard profile fields (all-time)
  user_id: z.string().uuid(),
  username: z.string(),
  avatar_url: z.string().nullable().optional(),
  predictor_rating: z.number(),
  success_rate: z.number(),
  total_predictions: z.number(),
  current_streak: z.number().optional(),
  // GW-specific fields (only when gameweek_id is provided)
  rank: z.number(),
  rating_change: z.number(),
  votes_in_gw: z.number(),
  success_rate_gw: z.number(),
});

export type GameweekLeaderboardEntry = z.infer<typeof GameweekLeaderboardEntrySchema>;

// Gameweek with votes (for dropdown)
export const GameweekWithVotesSchema = z.object({
  id: z.string().uuid(),
  number: z.number(),
  name: z.string(),
  finished: z.boolean(),
  is_current: z.boolean(),
  season_name: z.string().optional(),
  season_start_year: z.number().int().optional(),
});

export type GameweekWithVotes = z.infer<typeof GameweekWithVotesSchema>;

export const GameweeksWithVotesResponseSchema = z.object({
  gameweeks: z.array(GameweekWithVotesSchema),
});

export type GameweeksWithVotesResponse = z.infer<typeof GameweeksWithVotesResponseSchema>;
